import { addSpaceNumber } from 'utils/addSpaceNumber';
import { ActiveLimitType } from './types';

interface GetOrderAmountErrorMessageParams {
  balance: string | number;
  insufficientBalanceError: boolean;
  amountError?: string | null;
  activeLimitExceeded: boolean;
  activeLimitType: ActiveLimitType;
  activeLimitError: boolean;
  activeLimitRemaining: number | null;
  platformLimitError: boolean;
  min: number;
  max: number;
  isUnitBased: boolean;
}

export const getOrderAmountErrorMessage = ({
  balance,
  insufficientBalanceError,
  amountError,
  activeLimitExceeded,
  activeLimitType,
  activeLimitError,
  activeLimitRemaining,
  platformLimitError,
  min,
  max,
  isUnitBased,
}: GetOrderAmountErrorMessageParams): string | null => {
  if (activeLimitExceeded && !isUnitBased) {
    return activeLimitType === 'contract'
      ? 'Исполнитель уже превысил лимит по договору'
      : 'Исполнитель уже превысил месячный лимит';
  }

  if (activeLimitError && !isUnitBased) {
    return activeLimitType === 'contract'
      ? `Сумма превышает оставшийся лимит по договору ${addSpaceNumber(
          activeLimitRemaining?.toFixed(2),
        )} ₽`
      : `Сумма превышает оставшийся лимит исполнителя ${addSpaceNumber(
          activeLimitRemaining?.toFixed(2),
        )} ₽`;
  }

  if (!balance && !isUnitBased) {
    return 'Средств на балансе недостаточно для создания заказа';
  }

  if (insufficientBalanceError && !isUnitBased) {
    return 'Недостаточно средств на балансе';
  }

  if (amountError) {
    return amountError;
  }

  if (platformLimitError) {
    return `Допустимая сумма заказа от ${addSpaceNumber(min)} до ${addSpaceNumber(
      max,
    )} ₽`;
  }

  return null;
};
